<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="page__title_stock-movement">
            <h1 class="page-header">Движение по складу</h1>
            <div class="title__buttons">
              <div class="title__button_toggle-trash-bin">
                <button
                  class="btn btn-default btn-font btn-warning"
                  type="button"
                  @click="toggleTrashBinSearch"
                  :disabled="filtersWereApplied"
                >
                  <i class="fa fa-fw fa-trash"></i>
                  {{ searchInTrashBin ? `В корзине` : `Вне корзины` }}
                </button>
              </div>
              <div>
                <order-button
                  :order="order"
                  @click="changeListOrder"
                  with-icon
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ItemsPopover name="transfer-operation" :list="transferInfo" />
      <div class="row">
        <div class="col-lg-12">
          <div class="panel panel-default">
            <Preloader v-show="isLoadingNow" />
            <div v-show="(!notFound && !isLoadingNow)" class="panel-body">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th
                        v-for="column in tableInfo.columnNames"
                        :key="column"
                        class="list__column"
                      >
                        <span
                          v-if="isOrderColumn(column)"
                          class="list__column_with-icon"
                          @click="changeListOrder(column)"
                        >
                          {{ column }}
                          <i v-if="column === orderColumn" :class="orderIconCss" />
                        </span>
                        <span v-else>{{ column }}</span>
                      </th>
                      <th v-if="searchInTrashBin" class="list__column">
                        Дата удаления
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="record in filteredRecords"
                      class="row__container"
                      :key="record.id"
                    >
                      <OperationNameRow
                        :record="record"
                        @on-show-transfer="(info) => transferInfo = info"
                      />
                      <td class="list__row">
                        {{ getRow(record.count) }}
                      </td>
                      <td class="list__row">
                        {{ getRow(record.created_at) }}
                      </td>
                      <td class="list__row">
                        {{  getRow(record.operation_description, 32) }}
                      </td>
                      <td class="list__row">
                        <router-link
                          v-if="record.project_id"
                          :to="`projects/${record.project_id.id}`"
                          target="_blank"
                        >
                          {{ record.project_id.name }}
                        </router-link>
                        <span v-else>-</span>
                      </td>
                      <td class="list__row">
                        <router-link
                          v-if="record.purchase_order_id"
                          :to="`purchase_orders/${record.purchase_order_id.id}`"
                          target="_blank"
                        >
                          {{ `№ ${record.purchase_order_id.number}` }}
                        </router-link>
                        <span v-else>-</span>
                      </td>
                      <td class="list__row">
                        <router-link :to="getComponentLink(record)" target="_blank">
                          {{ getComponentText(record) }}
                        </router-link>
                      </td>
                      <td class="list__row">
                        {{ getRow(record.is_success) }}
                      </td>
                      <td
                        v-show="searchInTrashBin"
                        class="list__row"
                      >
                        {{ getRow(record.deleted_at) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="!notFound" class="list__footer">
                <div>
                  <Pagination
                    :pages-counter="pagesCounter"
                    :current-page="currentPage"
                    @select="(page) => changePage(page, 'getOperationsList')"
                  />
                </div>
                <div>
                  <button
                    class="btn btn-primary footer__button_add-operation"
                    @click="openedModals.newOperations = true"
                  >
                    Добавить операцию
                  </button>
                </div>
              </div>
            </div>
            <div v-show="(notFound && !iLoadingNow)" class="table__body_empty-results">
              <p class="results__text">Ничего не найдено</p>
              <div v-show="!searchInTrashBin" class="body__button_add-first-row">
                <button
                  type="button"
                  class="results__text btn btn-success"
                  @click="openedModals.newOperations = true"
                >
                  Добавить новую операцию
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewOperationsModal
      v-if="openedModals.newOperations"
      @close="openedModals.newOperations = false"
    />
  </div>
</template>

<script>
import ItemsPopover from '@/_shared/components/ui/ItemsPopover';
import Preloader from '@/_shared/components/ui/Preloader';
import Pagination from '@/_shared/components/ui/Pagination';
import FilterForm from '@/_shared/features/table/FilterForm';
import NewOperationsModal from '@/stock/components/NewOperationsModal';
import OperationNameRow from '@/stock/features/stock-movement/OperationNameRow';

import { stockOperationsService } from '@/stock/api-services';
import { usePagination, useOrderFilter, useTableHelper } from '@/_shared/mixins';
import { stockMovement, lists } from '@/stock/constants';
export default {
  mixins: [
    usePagination,
    useOrderFilter,
    useTableHelper,
  ],
  components: {
    ItemsPopover,
    NewOperationsModal,
    Preloader,
    Pagination,
    FilterForm,
    OperationNameRow,
  },
  data () {
    return {
      openedModals: {
        newOperations: false,
      },
      popup: {
        currentPage: 1,
        pagesCounter: 1,
      },
      orderFields: lists.stockMovement.orderFields,
      orderColumn: 'Дата операции',
      tableInfo: lists.stockMovement,
      tableName: 'stock_movement',
      searchingParams: null,
      popUpIsLoading: false,
      notFound: false,
      isLoadingNow: true,
      records: [],
      filteredRecords: [],
      showDetailModal: false,
      choosedDetailIds: [],
      choosedBoardIds: [],
      choosedPeripheryIds: [],
      choosedOperationDescription: '',
      choosedOperationStatus: '',
      choosedOperationStatus: '',
      showDataModal: false,
      choosedDate: [],
      showOperationsModal: false,
      choosedOperations: [],
      showOperationDescriptionModal: false,
      showOperationStatusModal: false,
      showOrdersModal: false,
      choosedOrderIds: [],
      newOperationModalIsVisible: false,
      filteredDetails: [],
      filteredPeripherys: [],
      filteredBoards: [],
      filteredOrders: [],
      searchInTrashBin: false,
      transferInfo: [],
    }
  },
  computed: {
    searchingDetailIds () {
      return this.cutAppliedFilterValue(this.choosedDetailIds, 7)
    },
    searchingBoardIds () {
      return this.cutAppliedFilterValue(this.choosedBoardIds, 7)
    },
    searchingPeripheryIds () {
      return this.cutAppliedFilterValue(this.choosedPeripheryIds, 7)
    },
    searchingData () {
      return this.choosedDate.length > 0
        ? this.choosedDate.length === 1
          ? ` (${new Date(this.choosedDate[0]).toLocaleDateString()})`
          : ` (${new Date(this.choosedDate[0]).toLocaleDateString()} - ${new Date(this.choosedDate[1]).toLocaleDateString()})`
        : null
    },
    searchingOperations () {
      const operationsNames = this.choosedOperations.map(({name}) => (
        name.toLowerCase()
      ))
      return this.cutAppliedFilterValue(operationsNames, 17)
    },
    searchingOrderIds () {
      return this.cutAppliedFilterValue(this.choosedOrderIds, 7)
    },
    searchingDescription() {
      let list = this.choosedOperationDescription.length > 0
        ? [this.choosedOperationDescription]
        : []
      return this.cutAppliedFilterValue(list, 7)
    },
    searchingStatus() {
      if (this.choosedOperationStatus === '') {
        return null
      }
      const status = this.choosedOperationStatus ? '(Успешные)' : '(Провальные)'
      return status
    },
    filtersWereInstalled() {
      const filtersNames = [
        'DetailIds', 'BoardIds', 'PeripheryIds', 'Date',
        'Operations', 'OrderIds', 'OperationDescription',
      ];
      let wereInstalled = false;
      filtersNames.forEach((filterName) => {
        const filterState = this[`choosed${filterName}`];
        if (filterState.length > 0) {
          wereInstalled = true;
        }
      });
      if (this.choosedOperationStatus !== '') {
        wereInstalled = true;
      }
      return wereInstalled;
    },
  },
  async mounted() {
    await this.getOperationsList();
  },
  provide() {
    return {
      createdAtFilterLabel: 'Дата операции',
      withoutUpdateDateFilter: true,
    };
  },
  methods: {
    async toggleTrashBinSearch() {
      this.searchInTrashBin = !this.searchInTrashBin;
      await this.resetFilters();
    },
    cutAppliedFilterValue(valuesList, limit = 16) {
      if (valuesList.length < 1) {
        return null
      }
      let text = ` (${valuesList.join(', ')})`
      if (text.length >= limit) {
        text = `${text.slice(0, limit - 1)}...)`
      }
      return text
    },
    async resetFilters() {
      this.searchingParams = null;
      this.filtersWereApplied = false;
      this.records = [];
      this.filteredRecords = [];
      this.notFound = false;
      await this.getOperationsList(1).then(() => {
        this.choosedPeripheryIds = [];
        this.choosedDetailIds = [];
        this.choosedOperationDescription = '';
        this.choosedOperationStatus = '';
        this.choosedBoardIds = [];
        this.choosedDate = [];
        this.choosedOperations = [];
        this.choosedOrderIds = [];
      });
    },
    async changeListOrder(columnName) {
      this.toggleOrder(columnName);
      if (this.searchingParams) {
        return await this.search();
      }
      await this.getOperationsList(1);
    },
    async getOperationsList(page = 1) {
      this.isLoadingNow = true;
      const filters = {
        page,
        searchInTrashBin: this.searchInTrashBin,
        order: this.order,
        orderColumn: this.orderFields[this.orderColumn],
      };
      await stockOperationsService.getAll(filters)
        .then((response) => {
          const { results, pagesCounter } = response;
          this.setData(results);
          this.usePagination(page, pagesCounter);
          this.notFound = (pagesCounter === 0);
          this.isLoadingNow = false;
        });
    },
    getComponentLink(record) {
      for (let keyName in stockMovement.tables) {
        if (record[keyName]) {
          const tableName = stockMovement.tables[keyName];
          const { id } = record[keyName];
          const slug = `${tableName}/${id}`;
          return slug;
        }
      }
    },
    getComponentText(record) {
      const list = stockMovement.entity.byForeignKey;
      for (let keyName in list) {
        if (record[keyName]) {
          const subtype = list[keyName];
          const { name } = record[keyName];
          const text = `${name} (${subtype})`;
          return text;
        }
      }
    },
    setData (newRecords) {
      this.records = newRecords
      this.filteredRecords = newRecords
    },
    prepareItems (filterName, items, searchingParams = []) {
      let updatedItems = []
      const foreignKeyFilters = ['detail_id', 'circuit_board_id', 'periphery_id'];
      if (filterName === 'created_at') {
        return this.choosedDate.length > 1
          ? `filter=${filterName},bt,${this.choosedDate[0]},${this.choosedDate[1]}`
          : `filter=${filterName},sw,${this.choosedDate[0]}`
      } else if (filterName === 'operation_name') {
        const operationsNames = items.map(({name}) => name)
        const param = `filter=${filterName},in,${operationsNames.join(',')}`
        updatedItems.push(param)
        return updatedItems.join('&')
      } else if (foreignKeyFilters.includes(filterName)) {
        const filtersWithNumber = searchingParams.toString().match(/filter\d/gi) || [];
        let paramKey = `filter${filtersWithNumber.length++}`;
        const param = `${paramKey}=${filterName},in,${items.join(',')}`
        updatedItems.push(param)
        return updatedItems.join('&')
      } else {
        const param = `filter=${filterName},in,${items.join(',')}`
        updatedItems.push(param)
        return updatedItems.join('&')
      }
    },
    async search () {
      this.isLoadingNow = true;
      this.filtersWereApplied = true;
      let searchingParams = []

      this.choosedDetailIds.length > 0 && searchingParams.push(
        this.prepareItems('detail_id', this.choosedDetailIds, searchingParams)
      )
      this.choosedBoardIds.length > 0 && searchingParams.push(
        this.prepareItems('circuit_board_id', this.choosedBoardIds, searchingParams)
      )
      this.choosedPeripheryIds.length > 0 && searchingParams.push(
        this.prepareItems('periphery_id', this.choosedPeripheryIds, searchingParams)
      )
      this.choosedOrderIds.length > 0 && searchingParams.push(
        this.prepareItems('purchase_order_id', this.choosedOrderIds, searchingParams)
      )
      this.choosedOperations.length > 0 && searchingParams.push(
        this.prepareItems('operation_name', this.choosedOperations, searchingParams)
      )
      this.choosedDate.length > 0 && searchingParams.push(
        this.prepareItems('created_at', this.choosedDate, searchingParams)
      )

      searchingParams = searchingParams.join('&') + '&join=details&join=circuit_boards'
        + '&join=providers&join=peripherals&join=purchase_orders';
      let deletedAtFilter = this.searchInTrashBin ? 'nis' : 'is'

      searchingParams += `&filter=deleted_at,${deletedAtFilter},null`
      if (this.choosedOperationDescription) {
        searchingParams += `&filter=operation_description,cs,${this.choosedOperationDescription}`
      }
      if (this.choosedOperationStatus !== '') {
        searchingParams += `&filter=is_success,eq,${+this.choosedOperationStatus}`
      }
      searchingParams = this.addOrderQueryParam(searchingParams);
      this.searchingParams = searchingParams
      searchingParams += '&page=1'
    },
    async openDetailModal () {
      this.toggleDetailModal(true)
      await this.updatePopupPage(1, [], "details", "filteredDetails")
      await this.updatePopupPage(1, [], "circuit_boards", "filteredBoards")
      await this.updatePopupPage(1, [], "peripherals", "filteredPeripherys")
    },
    toggleDetailModal (isShow) {
      this.showDetailModal = isShow
    },
    chooseDetails (detailIds, boardIds, peripheryIds) {
      this.choosedDetailIds = detailIds
      this.choosedBoardIds = boardIds
      this.choosedPeripheryIds = peripheryIds
      this.toggleDetailModal(false)
    },
    chooseOperationStatus(value) {
      this.choosedOperationStatus = value
      this.showOperationStatusModal = false
    },
    chooseOperationDescription(value) {
      this.choosedOperationDescription = value
      this.showOperationDescriptionModal = false
    },
    chooseDate (date) {
      this.choosedDate = date
      this.toggleDataModal(false)
    },
    toggleDataModal (isShow) {
      this.showDataModal = isShow
    },
    toggleOperationsModal (isShow) {
      this.showOperationsModal = isShow
    },
    chooseOperations (operations) {
      this.choosedOperations = operations
      this.toggleOperationsModal(false)
    },
    async openOrderModal () {
      this.toggleOrdersModal(true)
      await this.updatePopupPage(1, [], "purchase_orders", "filteredOrders")
    },
    toggleOrdersModal (isShow) {
      this.showOrdersModal = isShow
    },
    chooseOrders (orders) {
      this.choosedOrderIds = orders
      this.toggleOrdersModal(false)
    },
    async updatePopupPage(page, searchData = [], entity, resultsList) {
      alert('updated!');
    },
  },
}
</script>

<style scoped>
.table__body_empty-results {
  display: inline-flex;
  width: 100%;
  justify-content: center;
  padding-top: 6em;
  align-items: center;
  text-align: center;
  padding-bottom: 6em;
  flex-direction: column;
}

.table__filter {
  display: inline-flex;
  flex-direction: row;
}

.title__buttons {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
}

.title__button_toggle-trash-bin {
  margin-right: 0.5em;
}

.table__filter > *:not(:last-child),
.filter__button_reset {
  margin-right: 1em;
}
.custom-search-form {
  width: 100%;
}
form {
  width: 100%;
}
.input-group-btn > .btn:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.input-group-btn > .btn:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.row > .btn {
  border-radius: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table__filter > .btn {
  white-space: normal;
}

.page__title_stock-movement {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 1279px) {
  .table__filter {
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-row-gap: 1em;
    grid-column-gap: 1em;
  }
  .table__filter > *:not(:last-child),
  .filter__button_reset {
    margin-right: 0;
  }
}

@media (max-width: 991px) {
  .table__filter {
    grid-template-columns: auto;
  }
}

@media (max-width: 767px) {
  .page__title_stock-movement {
    flex-direction: column;
    justify-content: center;
  }

  .title__buttons {
    margin-bottom: 1.2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/stock/pages/StockMovementPage.vue